import React, { useEffect, useState } from 'react';
import '../CSS/HomeHighlights.css';

const HomeHighlights = () => {
    const [Spotlight, setSpotlight] = useState([]);

    function openAndLog(proxyUrl, reportName, reportType) {
        const userEmail = localStorage.getItem('user-email');
        if (userEmail) {
          fetch('/api/log-report', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
            body: JSON.stringify({ reportName, reportType, userEmail })
          }).catch(() => {});
        }
        window.open(proxyUrl, '_blank', 'noopener,noreferrer');
      }
      
      const addProxyUrls = (items, reportType = 'FeaturedInsights') =>
        items.map(item => {
          const proxyUrl = `/api/highlights/${reportType}/${encodeURIComponent(item.name)}.pdf`;
          return {
            ...item,
            proxyUrl,
            open: () => openAndLog(proxyUrl, item.name, reportType)
          };
        });

    useEffect(() => {
        fetch('/api/hello')
            .then((response) => response.json())
            .then((data) => {
                // ✅ Add proxy URLs and limit to first 15
                const featuredWithProxy = addProxyUrls(data.FeaturedInsights).slice(0, 15);
                setSpotlight(featuredWithProxy);
            })
            .catch((error) => {
                console.error('Error fetching reports data:', error);
            });
    }, []);

    return (
        <div className="home-highlights">
            <ul className="list-item-home">
                {Spotlight.map((item, index) => (
                    <li key={index}>
                         <a
          href={item.proxyUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();   // always use our opener
            item.open();          // calls openAndLog(...)
          }}
        >
          {item.name}
        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HomeHighlights;
